export default __webpack_public_path__ + "static/media/madame_detail16.b98220ed.jpg";